/**
 * @return {String}
 */
export default function privacyPolicyUrl() {
  return '/document/privacy-policy';
}



// WEBPACK FOOTER //
// ./src/utils/url/privacyPolicyUrl.js